import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/app/[locale]/error.tsx");
